import { HTTP, BLOB, IHttpResponse, HTTP_UPLOAD } from "./http";
import {
	UPLOAD_DOCUMENT,
	UPLOAD_CLIENT_DOCUMENT,
	UPLOAD_DOCUMENT_ONBOARD,
	UPLOAD_DOCUMENT_REQUESTED,
	GET_CANDIDATE_DOCUMENTS,
	GET_CANDIDATE_DOCUMENTS_ONBOARD,
	GET_CANDIDATE_DOCUMENTS_REQUESTED,
	GET_CANDIDATE_DOCUMENT,
	DELETE_CANDIDATE_DOCUMENT,
	DELETE_INDIVIDUAL_FILE,
	DELETE_CANDIDATE_DOCUMENT_ONBOARD,
	DELETE_CANDIDATE_DOCUMENT_REQUESTED,
	UPLOAD_IMAGE,
	REQUEST_DOCUMENTS,
	DOCUMENT_REQUEST_SUBMITTED,
	GET_DOCUMENT,
	DOWNLOAD_DOCUMENT_ONBOARD,
	DOWNLOAD_DOCUMENT_TIMESHEET,
	UPLOAD_IMAGE_ONBOARD,
	GENERIC_DOCUMENT,
	DOWNLOAD_DOCUMENT_TIMESHEET_CANDIDATE,
	UPDATE_DOCUMENT,
	GET_COMPANY_DOCUMENTS,
	GET_COMPANY_DOCUMENTS_ALL,
	GET_COMPANY_BOOKING_ATTACHMENTS,
	DOWNLOAD_DOCUMENT_EXTERNAL,
	ASSESS_DOCUMENT_QUALITY,
} from "../../config/endpoints";
import { HeadersAuth, HeadersNoAuth } from "./http";
import { DocumentInterface } from "../../_types/document";
import { DocumentLevelTypes } from "../../_enums/rightToWork.enum";

export const UploadDocument = (Token: string, DATA, UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE) => {
	return HTTP_UPLOAD({
		Method: "POST",
		Url: UPLOAD_DOCUMENT(UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE),
		Data: DATA ?? null,
		Headers: {
			Authorization: `Bearer ${Token}`,
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}) as Promise<IHttpResponse>;
};

export const UploadClientDocument = (Token: string, DATA, UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE) => {
	return HTTP_UPLOAD({
		Method: "POST",
		Url: UPLOAD_CLIENT_DOCUMENT(UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE),
		Data: DATA ?? null,
		Headers: {
			Authorization: `Bearer ${Token}`,
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}) as Promise<IHttpResponse>;
};

export const UploadDocumentOnboard = (DATA, UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE, Token: string) => {
	return HTTP_UPLOAD({
		Method: "POST",
		Url: UPLOAD_DOCUMENT_ONBOARD(UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE, Token),
		Data: DATA ?? null,
		Headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}) as Promise<IHttpResponse>;
};

export const UploadDocumentRequested = (DATA, UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE, Token: string) => {
	return HTTP_UPLOAD({
		Method: "POST",
		Url: UPLOAD_DOCUMENT_REQUESTED(UPLOAD_TYPE, USER_ID, DOCUMENT_TYPE, Token),
		Data: DATA ?? null,
		Headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}) as Promise<IHttpResponse>;
};

export const GetCandidateDocumentsServer = (Token: string, CANDIDATE_ID, DOCUMENT_TYPE) => {
	return HTTP({
		Method: "GET",
		Url: GET_CANDIDATE_DOCUMENTS(CANDIDATE_ID, DOCUMENT_TYPE),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCandidateDocumentsServerOnboard = (CANDIDATE_ID, DOCUMENT_TYPE, Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CANDIDATE_DOCUMENTS_ONBOARD(CANDIDATE_ID, DOCUMENT_TYPE, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const GetCandidateDocuments = (Token: string, CANDIDATE_ID, DOCUMENT_TYPE) => {
	return HTTP({
		Method: "GET",
		Url: GET_CANDIDATE_DOCUMENTS(CANDIDATE_ID, DOCUMENT_TYPE),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCompanyDocuments = (Token: string, DocumentLevelType: DocumentLevelTypes) => {
	return HTTP({
		Method: "GET",
		Url: GET_COMPANY_DOCUMENTS(DocumentLevelType),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCompanyBookingAttachments = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_COMPANY_BOOKING_ATTACHMENTS,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCompanyDocumentsAll = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_COMPANY_DOCUMENTS_ALL,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCandidateDocumentsOnboard = (CANDIDATE_ID, DOCUMENT_TYPE, Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CANDIDATE_DOCUMENTS_ONBOARD(CANDIDATE_ID, DOCUMENT_TYPE, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const GetCandidateDocumentsRequested = (CANDIDATE_ID, DOCUMENT_TYPE, Token: string) => {
	return HTTP({
		Method: "GET",
		Url: GET_CANDIDATE_DOCUMENTS_REQUESTED(CANDIDATE_ID, DOCUMENT_TYPE, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const GetCandidateDocument = (Token: string, DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE) => {
	return BLOB({
		Method: "GET",
		Url: GET_CANDIDATE_DOCUMENT(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const DeleteCandidateDocument = (Token: string, DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE) => {
	return HTTP({
		Method: "DELETE",
		Url: DELETE_CANDIDATE_DOCUMENT(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const DeleteIndividualFile = (Token: string, DOCUMENT_ID: string, FILE_REFERENCE: string) => {
	return HTTP({
		Method: "DELETE",
		Url: DELETE_INDIVIDUAL_FILE(DOCUMENT_ID, FILE_REFERENCE),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const DeleteCandidateDocumentOnboard = (DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, TOKEN) => {
	return HTTP({
		Method: "DELETE",
		Url: DELETE_CANDIDATE_DOCUMENT_ONBOARD(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, TOKEN),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const DeleteCandidateDocumentRequested = (DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, TOKEN) => {
	return HTTP({
		Method: "DELETE",
		Url: DELETE_CANDIDATE_DOCUMENT_REQUESTED(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, TOKEN),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const UploadImage = (Token: string, DATA, UPLOAD_TYPE) => {
	return HTTP_UPLOAD({
		Method: "POST",
		Url: UPLOAD_IMAGE(UPLOAD_TYPE),
		Data: DATA,
		Headers: {
			Authorization: `Bearer ${Token}`,
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}) as Promise<IHttpResponse>;
};

export const UploadToContainer = (Token: string, DATA, CONTAINER) => {
	return HTTP_UPLOAD({
		Method: "POST",
		Url: GENERIC_DOCUMENT(CONTAINER),
		Data: DATA ?? null,
		Headers: {
			Authorization: `Bearer ${Token}`,
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}) as Promise<IHttpResponse>;
};

export const UploadImageOnboarding = (DATA, UPLOAD_TYPE, Token: string) => {
	return HTTP_UPLOAD({
		Method: "POST",
		Url: UPLOAD_IMAGE_ONBOARD(UPLOAD_TYPE, Token),
		Data: DATA ?? null,
		Headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
	}) as Promise<IHttpResponse>;
};

export const RequestDocuments = (Token: string, DATA) => {
	return HTTP({
		Method: "POST",
		Url: REQUEST_DOCUMENTS,
		Data: DATA ?? null,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const DocumentRequestSubmitted = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: DOCUMENT_REQUEST_SUBMITTED(Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const DownloadFile = (Token: string, DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE) => {
	return BLOB({
		Method: "GET",
		Url: GET_DOCUMENT(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const DownloadFileOnboard = (DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, Token: string) => {
	return BLOB({
		Method: "GET",
		Url: DOWNLOAD_DOCUMENT_ONBOARD(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const DownloadFileTimesheet = (DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, TYPE, Token: string) => {
	return BLOB({
		Method: "GET",
		Url: TYPE === 1 ? DOWNLOAD_DOCUMENT_TIMESHEET(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, Token) : DOWNLOAD_DOCUMENT_TIMESHEET_CANDIDATE(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const UpdateDocument = (Token: string, DOCUMENT_ID, DATA: Partial<DocumentInterface>) => {
	return HTTP({
		Method: "PUT",
		Url: UPDATE_DOCUMENT(DOCUMENT_ID),
		Headers: HeadersAuth(Token),
		Data: DATA,
	}) as Promise<IHttpResponse>;
};

export const UpdateDocumentPartial = (Token: string, DOCUMENT_ID, DATA: Partial<DocumentInterface>) => {
	return HTTP({
		Method: "PATCH",
		Url: UPDATE_DOCUMENT(DOCUMENT_ID),
		Headers: HeadersAuth(Token),
		Data: DATA,
	}) as Promise<IHttpResponse>;
};

export const DownloadFileTExternal = (DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, Token: string) => {
	return BLOB({
		Method: "GET",
		Url: DOWNLOAD_DOCUMENT_EXTERNAL(DOCUMENT_REFERENCE_ID, DOCUMENT_TYPE, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const AssessDocumentQuality = (Token: string, DOCUMENT_ID: string) => {
	return HTTP({
		Method: "POST",
		Url: ASSESS_DOCUMENT_QUALITY(DOCUMENT_ID),
		Headers: HeadersAuth(Token),
		Data: {},
	}) as Promise<IHttpResponse>;
};
